




import { Component, Vue } from 'vue-property-decorator'
import CallDetail from './components/CallDetail.vue'

@Component({
  name: 'CreateCall',
  components: {
    CallDetail
  }
})
export default class extends Vue {}
